
class MobileNav {

    constructor(element) {
        this.element = element;
        this.initialize();
    }

    initialize() {
        if (!this.element || this.element.classList.contains('init')) {
            return;
        }
        this.element.classList.add('init');

        for (const button of this.element.querySelectorAll('button[aria-controls]')) {
            button.addEventListener('click', this.handleToggle);
        }

        // Close a submenu when focus leaves its containing <li> entirely
        // (e.g. Tab past the last item inside it, or click a non-focusable
        // spot on the page). event.relatedTarget is null in that case, but
        // it is ALSO null when the whole tab/window loses focus (clicking
        // into devtools, alt-tabbing, clicking the URL bar) - that isn't the
        // user navigating away within the page, so document.hasFocus() is
        // used to tell the two apart and avoid closing on a mere window blur.
        for (const item of this.element.querySelectorAll('.mobile-nav__item:has(button[aria-controls])')) {
            item.addEventListener('focusout', (event) => {
                const relatedTarget = event.relatedTarget;

                // Focus moving to ANY disclosure toggle button - in this menu
                // or a different one further down the drawer - means a click
                // on it is already in flight: that button's own handleToggle
                // will resolve things once the click actually fires. Don't
                // close here instead - this handler runs on mousedown (focus
                // shift happens before mouseup/click), so closing now would
                // collapse this item mid-click. If this item sits above the
                // one being clicked (in this menu or a later one), that
                // collapse shifts the page up and moves the target out from
                // under the pointer before the click lands, so it never opens.
                if (relatedTarget?.matches('[aria-controls]')) {
                    return;
                }
                if (relatedTarget ? item.contains(relatedTarget) : !document.hasFocus()) {
                    return;
                }
                const button = item.querySelector(':scope > button[aria-controls]');
                if (button) button.setAttribute('aria-expanded', 'false');
            });
        }

        // On Escape: close the innermost submenu containing the focused element
        // and return focus to its controlling button.
        this.element.addEventListener('keydown', (event) => {
            if (event.key !== 'Escape') return;

            const openSubmenu = document.activeElement.closest('[id^="submenu-"]');
            if (openSubmenu) {
                const controlButton = this.element.querySelector(`[aria-controls="${openSubmenu.id}"]`);
                if (controlButton) {
                    controlButton.setAttribute('aria-expanded', 'false');
                    controlButton.focus();
                    return;
                }
            }
            // Fallback: collapse everything.
            for (const button of this.element.querySelectorAll('button[aria-controls]')) {
                button.setAttribute('aria-expanded', 'false');
            }
        });
    }

    handleToggle = (event) => {
        const button = event.currentTarget;
        const isOpen = button.getAttribute('aria-expanded') === 'true';

        // Close every other open toggle in the drawer - any level, any menu
        // (Main / Utility / Utility Secondary / Department all share the
        // .mobile-nav class) - except ancestors of the one just clicked:
        // those control the submenu this button lives inside, so they have
        // to stay open for it to be reachable at all.
        for (const other of document.querySelectorAll('.mobile-nav button[aria-controls][aria-expanded="true"]')) {
            if (other === button) continue;
            const controlled = document.getElementById(other.getAttribute('aria-controls'));
            if (controlled?.contains(button)) continue;
            other.setAttribute('aria-expanded', 'false');
        }

        button.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    }
}

(function (Drupal) {
    Drupal.behaviors.mobileNav = {
        attach: function (context, settings) {
            once('mobile-nav', '.mobile-nav', context).forEach((element) => {
                new MobileNav(element);
            });
        }
    }
})(Drupal);
